import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Img from "gatsby-image";
import {Link} from 'gatsby';
import Parser from 'html-react-parser';

export default class TagPostList extends Component {
    constructor (props) {
      super(props)
    }

    renderTagLabel(tag) {
        if(tag.document && tag.document[0] && tag.document[0].data && tag.document[0].data.label)
        {
            return tag.document[0].data.label
        } else {
            return tag.slug
        }
    }

    render() {
      const { posts } = this.props;
      return (
          <section>
              <div className="content tagContainer">
                {posts.map(({ node: post }, i) => (
                    <div key={i} className="tagCard">
                        <div className="postImage">
                        {post.data.image.localFile != null ? (
                            <Link to={`/blog/${post.uid}`}><Img fluid={post.data.image.localFile.childImageSharp.fluid}/></Link>
                        ) : ''}
                        </div>
                        <div className="postDetail">
                            <span className="datePost">{post.data.publishdate}</span>
                            <span className="tagPostList">
                                {post.data.tags.map(({tag:tagItem}, k) => (
                                    <Link key={k} to={`/tag/${tagItem.slug}`}>#{this.renderTagLabel(tagItem)}</Link>
                                ))}
                            </span>
                            <Link to={`/blog/${post.uid}`}>
                                <h3>{post.data.title.text}</h3>
                            </Link>
                            <Link to={`/blog/${post.uid}`}>
                                {Parser(post.data.subtitle.html)}
                            </Link>
                        </div>
                    </div>
                ))}  
            </div>   
          </section>    
      )
    }
}
